import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

export default function Login({ onLogin, onBack, onForgot }) {
  const [isAdminPage, setIsAdminPage] = useState(window.location.search.includes('admin'));
  const [username, setUsername]   = useState('');
  const [password, setPassword]   = useState('');
  const [rememberMe, setRemember] = useState(false);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);

  useEffect(() => {
    const id = 'seva-login-styles';
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const el = document.createElement('style');
    el.id = id;
    el.textContent = `
      .lg-input:focus { border-color:#6366f1!important; box-shadow:0 0 0 3px rgba(99,102,241,.12)!important; outline:none; }
      .lg-btn-back:hover { background:rgba(255,255,255,.1)!important; color:rgba(255,255,255,.85)!important; }
    `;
    document.head.appendChild(el);
    return () => el.remove();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (isAdminPage) {
        await api.adminLogin(username, password, rememberMe);
        onLogin({ isAdmin: true });
      } else {
        await api.login(username, password, rememberMe);
        onLogin({ isAdmin: false });
      }
    } catch {
      setError('Invalid credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, overflowY:'auto', background:'#0f172a',
      backgroundImage:'radial-gradient(ellipse 80% 60% at 50% 0%,rgba(79,70,229,.22) 0%,transparent 65%)',
      fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif' }}>

      {/* Nav */}
      <nav style={{ height:64, padding:'0 5%', display:'flex', alignItems:'center',
        justifyContent:'space-between', borderBottom:'1px solid rgba(255,255,255,.06)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:34, height:34, borderRadius:9, overflow:'hidden', flexShrink:0 }}>
            <img src="/icon-192.png" alt="Seva" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
          </div>
          <span style={{ fontSize:18, fontWeight:800, color:'#f1f5f9', letterSpacing:'-0.3px' }}>Seva</span>
        </div>
        {onBack && (
          <button onClick={onBack} className="lg-btn-back"
            style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.1)',
              borderRadius:8, padding:'7px 16px', color:'rgba(255,255,255,.55)', fontSize:14,
              fontWeight:500, cursor:'pointer', transition:'background .15s, color .15s',
              display:'flex', alignItems:'center', gap:6 }}>
            ← Back
          </button>
        )}
      </nav>

      {/* Card */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
        minHeight:'calc(100vh - 64px)', padding:'40px 5%' }}>
        <div style={{ width:400, padding:'40px 44px', background:'#ffffff',
          border:'1px solid rgba(255,255,255,.08)', borderRadius:22,
          boxShadow:'0 40px 80px rgba(0,0,0,.45)' }}>

          <div style={{ textAlign:'center', marginBottom:28 }}>
            <div style={{ width:52, height:52, borderRadius:14, overflow:'hidden',
              margin:'0 auto 16px', boxShadow:'0 4px 16px rgba(0,0,0,.25)' }}>
              <img src="/icon-192.png" alt="Seva"
                style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:14 }} />
            </div>
            <h1 style={{ fontSize:26, fontWeight:800, color:'#0f172a', margin:'0 0 6px', letterSpacing:'-0.5px' }}>Seva</h1>
            <p style={{ fontSize:14, color:'#64748b', margin:0, lineHeight:1.5 }}>
              {isAdminPage ? 'Admin access' : 'Restaurant reservation management, powered by AI.'}
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <h2 style={{ fontSize:15, fontWeight:700, color:'#1e293b', margin:'0 0 18px' }}>
              {isAdminPage ? 'Admin sign in' : 'Staff sign in'}
            </h2>

            {error && (
              <div style={{ background:'#fef2f2', color:'#dc2626', border:'1px solid #fecaca',
                borderRadius:10, padding:'10px 14px', fontSize:13, marginBottom:18 }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom:16 }}>
              <label style={lbl}>Username</label>
              <input className="lg-input" style={inp} type="text"
                value={username} onChange={e => setUsername(e.target.value)} autoFocus required />
            </div>

            <div style={{ marginBottom:16 }}>
              <label style={lbl}>Password</label>
              <input className="lg-input" style={inp} type="password"
                value={password} onChange={e => setPassword(e.target.value)} required />
            </div>

            <label style={{ display:'flex', alignItems:'center', gap:9, marginBottom:20, cursor:'pointer' }}>
              <div
                onClick={() => setRemember(r => !r)}
                style={{ width:18, height:18, borderRadius:5, border:'1.5px solid',
                  borderColor: rememberMe ? '#4f46e5' : '#cbd5e1',
                  background: rememberMe ? '#4f46e5' : '#f8fafc',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  flexShrink:0, transition:'all .15s', cursor:'pointer' }}>
                {rememberMe && (
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </div>
              <span style={{ fontSize:13, color:'#475569', userSelect:'none' }}
                onClick={() => setRemember(r => !r)}>Keep me signed in</span>
            </label>

            <button type="submit"
              style={{ width:'100%', background:'#4f46e5', border:'none', borderRadius:10,
                padding:'13px', fontSize:15, fontWeight:700, color:'#fff', cursor:'pointer',
                boxShadow:'0 2px 12px rgba(79,70,229,.3)', transition:'opacity .15s' }}
              disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in →'}
            </button>
          </form>

          {!isAdminPage && onForgot && (
            <p style={{ marginTop:16, textAlign:'center', marginBottom:0 }}>
              <button onClick={onForgot}
                style={{ background:'none', border:'none', color:'#4f46e5', fontSize:13, cursor:'pointer', padding:0, fontWeight:600 }}>
                Forgot your details?
              </button>
            </p>
          )}

          <p style={{ marginTop:12, textAlign:'center', marginBottom:0 }}>
            {isAdminPage
              ? <button onClick={() => { setIsAdminPage(false); setError(''); setUsername(''); setPassword(''); }}
                  style={{ background:'none', border:'none', color:'#94a3b8', fontSize:11, cursor:'pointer', padding:0 }}>← Staff login</button>
              : <button onClick={() => { setIsAdminPage(true); setError(''); setUsername(''); setPassword(''); }}
                  style={{ background:'none', border:'none', color:'#94a3b8', fontSize:11, cursor:'pointer', padding:0 }}>Admin</button>
            }
          </p>
        </div>
      </div>
    </div>
  );
}

const lbl = { display:'block', fontSize:11, fontWeight:700, color:'#64748b', marginBottom:6, textTransform:'uppercase', letterSpacing:'.06em' };
const inp = { width:'100%', background:'#f8fafc', border:'1.5px solid #e2e8f0', borderRadius:10, padding:'11px 14px', fontSize:14, color:'#0f172a', outline:'none', boxSizing:'border-box', transition:'border-color .18s, box-shadow .18s', fontFamily:'inherit' };
